import { Component } from 'react';
import styled from '@emotion/styled';

// Components
import CTAButton from "../../../CTAButton"

const WidgetBody = styled.div`
  background-image: url(${props => props.backgroundImageUrl});
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
  padding: 6em 1em 1em;
  position: relative;
  width: 100%;

  @media (max-width: 480px) {
    background-size: 200%;
    padding-top: 5.25em;
  }
`;

const RoofingDiagram = styled.div`
  background-image: url(${props => props.imageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 82%;
  position: absolute;
  right: -30%;
  top: 52%;
  transform: translateY(-50%);
  width: 92%;

  @media (max-width: 600px) {
    height: 68%;
    right: -29%;
    width: 82%;
  }

  @media (max-width: 480px) {
    position: absolute;
    right: auto;
  }
`;

const WidgetContent = styled.div`
  color: #333333;
  display: inline-block;
  max-width: 375px;
  min-height: 32em;
  padding: 1em 1em 4em;
  position: relative;
  width: 80%;

  &:before {
    background-color: #FFFFFF;
    content: "";
    height: 100%;
    left: 0;
    opacity: 0.6;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  @media (max-width: 600px) {
    max-width: 320px;
    min-height: 28em;
    padding-bottom: 4.2em;
  }

  @media (max-width: 480px) {
    max-width: none;
    padding-bottom: 4.7em;
    width: 100%;
  }
`;

const ContentHeader = styled.div`
  border-bottom: 1px solid #FFFFFF;
  display: inline-block;
  margin-bottom: 1em;
  padding-bottom: 1em;
  position: relative;
  width: 100%;
`;

const BackLink = styled.a`
  align-items: center;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-flex;
  line-height: 150%;
  text-decoration: none;

  &:hover {
    color: #FFFFFF;
  }

  &:before {
    align-self: end;
    content: "";
    display: inline-block;
    font-family: icomoon;
    line-height: 1.3;
    margin-right: 0.5em;
    position: relative;
    transform: scaleX(-1) translate(0px, -10%);
  }
`;

const WidgetHeading = styled.div`
  font-size: 1.222em;
  font-weight: 700;
  line-height: 130%;
  margin-bottom: 0.75em;
  position: relative;

  @media (max-width: 600px) {
    font-size: 1.125em;
  }

  @media (max-width: 480px) {
    font-size: 1.286em;
  }
`;

const Paragraph = styled.p`
  font-weight: 500;
  line-height: 150%;
  margin-bottom: 1em;
  position: relative;
`;

const RoofingImages = styled.div`
  align-items: center;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

const RoofingImageContainer = styled.div`
  display: inline-block;
  margin-bottom: 1em;
  position: relative;
  width: 48%;
`;

const RoofingImage = styled.div`
  background-image: url(${props => props.imageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
  margin-bottom: 0.5em;
  padding-bottom: 6.5em;
  position: relative;
  width: 100%;
`;

const RoofingImageTitle = styled.div`
  color: #333;
  display: inline-block;
  font-size: 0.889em;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
`;

const ContentFooter = styled.div`
  border-top: 1px solid #FFFFFF;
  bottom: 0;
  display: inline-block;
  left: 1em;
  padding-top: 1em;
  position: absolute;
  width: calc(100% - 2em);
`;

const MainCta = styled(CTAButton)`
  align-items: center;
  background-color: #000000;
  border: 2px solid #000000;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.778em;
  line-height: 1.2;
  padding: 0.6em 1em;
  position: relative;
  text-decoration: none;

  @media (max-width: 600px) {
    font-size: 0.875em;
  }

  @media (max-width: 480px) {
    font-size: 1em;
  }

  &:hover {
    color: #FFFFFF;
  }

  &:hover:before {
    border-color: #FFFFFF;
  }

  &:before {
    border: 2px solid transparent;
    bottom: 0;
    content: "";
    display: inline-block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  &:after {
    align-self: end;
    content: "";
    display: inline-block;
    font-family: icomoon;
    line-height: 1;
    margin-left: 1.4em;
    position: relative;
    transform: translateY(-10%);
  }

  margin-bottom: 1em;
  position: relative;
`;

export default class TPRSBodyInner extends Component {
  render() {
    const {
      bodyImageUrl,
      roofImageUrl,
      backEvent,
      title,
      paragraph,
      photos,
      ctaText,
      clickEvent,
      back
    } = this.props;

    return (
      <WidgetBody backgroundImageUrl={bodyImageUrl}>
        <RoofingDiagram imageUrl={roofImageUrl} />
        <WidgetContent>
          <ContentHeader>
            <BackLink onClick={backEvent}>{back}</BackLink>
          </ContentHeader>
          <WidgetHeading>{title}</WidgetHeading>
          <Paragraph>{paragraph}</Paragraph>
          <RoofingImages>
            {photos.map((photo, index) =>
              <RoofingImageContainer key={index}>
                <RoofingImage imageUrl={photo.imageUrl} title={photo.title} />
                <RoofingImageTitle>{photo.title}</RoofingImageTitle>
              </RoofingImageContainer>
            )}
          </RoofingImages>
          <ContentFooter>
            {(ctaText && clickEvent) &&
              <MainCta
                text={ctaText}
                onClick={clickEvent}
                data-track="learn-more"
                data-track-element-location="tprs-inner-body"
                data-track-destination={ctaText}
              />
            }
          </ContentFooter>
        </WidgetContent>
      </WidgetBody>
    );
  }
}
